import React from 'react';

import { FormItem, FormListItem, TextFieldItem, IconTextButton, Space, Icon, IconButton } from 'ui-lib';

import { inputAlphanumericRule } from './form-utils';
import { IDeviceGroupDataInput } from '../../../dto/device-group-dto';
import componentCss from './component.css';

export interface IAttributeDisplayProps {
    key: string;
    value: string;
}

export interface IAttributeFormItemProps {
    code: string;
    className?: string;
    label?: string;
    initialValue: IAttributeDisplayProps[];
    readonly?: boolean;
}

export function getIoTAttribute(attributes: IAttributeDisplayProps[]): IDeviceGroupDataInput {
    if (!attributes) return {};
    return attributes.reduce((previous, current) => {
        previous[current.key] = current.value;
        return previous;
    }, {});
}

export function getDisplayAttribute(attribute: IDeviceGroupDataInput, omitKeys: string[] = []): IAttributeDisplayProps[] {
    if (!attribute) return [];
    return Object.keys(attribute).reduce((previous, key) => {
        if (omitKeys.includes(key)) return previous;
        previous.push({
            key: key,
            value: attribute[key],
        });

        return previous;
    }, []);
}

const icons = {
    plus: 'file-plus',
    minimize: 'close',
};

const inputAttributeRule = inputAlphanumericRule(25, ['UNDERSCORE', 'SPACE', 'MINUS']);

export const AttributeFormItem = (props: IAttributeFormItemProps) => {
    return (
        <FormListItem
            code={props.code}
            label={props.label}
            labelCol={{ span: 5 }}
            labelAlign={'right'}
            colon={false}
            formListProps={{
                initialValue: props.initialValue,
                name: 'deviceGroupAttribute',
                children: (fields, { add, remove }) => (
                    <React.Fragment>
                        {fields.map(({ key, name, ...restField }) => (
                            <Space key={key} className={props.className} align='baseline'>
                                <TextFieldItem
                                    code={'attributeKey'}
                                    disabled={props.readonly}
                                    placeholder='Attribute key'
                                    name={[name, 'key']}
                                    rule={[
                                        {
                                            required: true,
                                            message: 'Missing the attribute key',
                                        },
                                        inputAttributeRule,
                                    ]}
                                    {...restField}
                                />
                                <TextFieldItem
                                    disabled={props.readonly}
                                    code={'attributeValue'}
                                    placeholder='Attribute value'
                                    name={[name, 'value']}
                                    rule={[
                                        { required: true, message: 'Missing the attribute value' },
                                        inputAttributeRule,
                                    ]}
                                    {...restField}
                                />
                                <IconButton
                                    iconName={icons.minimize as any}
                                    iconClassName={componentCss['attribute-remove-button']}
                                    size='SMALL'
                                    onClick={() => remove(name)}
                                    disabled={props.readonly}
                                />
                            </Space>
                        ))}
                        <FormItem
                            code={'addAttributeButton'}
                            child={
                                <IconTextButton
                                    onClick={() => add()}
                                    iconName={icons.plus as any}
                                    disabled={props.readonly}
                                    key='addAttribute'
                                    label='Add Attribute'
                                    type='primary'
                                />
                            }
                        />
                    </React.Fragment>
                ),
            }}
        />
    );
};
